import React from 'react'
import { string, func, shape, bool, object } from 'prop-types'
import { translate } from 'react-i18next'
import config from '../../config'
import { Authenticated } from './Authenticated'
import { Unauthenticated } from './Unauthenticated'
import './Header.css'

const HeaderUI = ({
    seo = {},
    isConnected,
    isMenuOpen,
    onOpenMenu,
    closeMenu,
    activePage,
    account,
    t
}) => (
    <header>
        {isMenuOpen ? <div className='nav-backdrop' onClick={closeMenu} /> : ''}
        <section className='header'>
          <a href={config.homepage_url}>
            <img className='header__logo' src='/app/images/logo.png' alt={seo.alt} title={seo.logo} />
          </a>
          <div className={'header__burger ' + (isMenuOpen ? 'active' : '')} onClick={onOpenMenu}>
            <div className='header__line' />
            <div className='header__line' />
            <div className='header__line' />
          </div>
          <nav className={'nav ' + (isMenuOpen ? 'active' : '')}>
            {
                isConnected ?
                <Authenticated t={t} closeMenu={closeMenu} account={account}/> :
                <Unauthenticated t={t} activePage={activePage} closeMenu={closeMenu} />
            }
          </nav>
        </section>
      </header>
)

HeaderUI.propTypes = {
    seo: shape({
        alt: string,
        logo: string
    }),
    activePage: string,
    isConnected: bool,
    account: object,
    onOpenMenu: func,
    closeMenu: func,
    t: func
}
export const HeaderComponent = translate()(HeaderUI)



// WEBPACK FOOTER //
// ./src/components/header/HeaderComponent.js